import React from "react";

export const AdminTaxSymbol = () => (
  <svg
    width="56"
    height="56"
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M31.263 23.2058L20.3192 34L17.237 30.96C15.5877 29.3331 15.5877 26.6955 17.237 25.0687L25.1944 17.2201C26.8437 15.5933 29.5179 15.5933 31.1673 17.2201L31.263 17.3145C32.9123 18.9414 32.9123 21.579 31.263 23.2058Z"
      fill="url(#paint0_linear_5723_7976)"
    />
    <path
      d="M24.737 32.7942L35.6808 22L38.763 25.04C40.4123 26.6669 40.4123 29.3045 38.763 30.9313L30.8056 38.7799C29.1563 40.4067 26.4821 40.4067 24.8327 38.7799L24.737 38.6855C23.0877 37.0586 23.0877 34.421 24.737 32.7942Z"
      fill="url(#paint1_linear_5723_7976)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_5723_7976"
        x1="16"
        y1="25"
        x2="32.5"
        y2="25"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#8B08FD" />
        <stop offset="1" stopColor="#5622FF" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_5723_7976"
        x1="23.5"
        y1="31"
        x2="40"
        y2="31"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#8B08FD" />
        <stop offset="1" stopColor="#5622FF" />
      </linearGradient>
    </defs>
  </svg>
);
